import { useState } from 'react'
import { MessageCircle, X, Send } from 'lucide-react'
import { useFranchiseData } from '../hooks/useFranchiseData'
import { API_CONFIG } from '../config/api'

const INDOJET_NAVY = '#182C78'

const ChatWidget = () => {
  const [isOpen, setIsOpen] = useState(false)
  const { franchiseData, loading } = useFranchiseData()

  if (loading || !franchiseData) {
    return null
  }

  const buildChatUrl = () => {
    const params = new URLSearchParams({
      agency_id: franchiseData.subdomain || API_CONFIG.FRANCHISE_ID,
      subdomain: franchiseData.subdomain || API_CONFIG.FRANCHISE_ID,
      franchise_id: API_CONFIG.FRANCHISE_ID,
      topbar_color: INDOJET_NAVY,
      button_color: INDOJET_NAVY,
      main_background_color: '#F1F1F1',
      secondary_background_color: '#FFFFFF',
      custom: 'true'
    })

    return `https://acms-frontend-agent-embed-prod-1019535049697.europe-west2.run.app?${params.toString()}`
  }

  const chatUrl = buildChatUrl()

  return (
    <>
      {/* Chat Button */}
      {!isOpen && (
        <button
          onClick={() => setIsOpen(true)}
          style={{ backgroundColor: INDOJET_NAVY }}
          className="fixed bottom-8 right-24 text-white p-4 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 z-50 flex items-center gap-2 group"
          aria-label="Open AI Travel Assistant"
        >
          <MessageCircle size={24} className="group-hover:rotate-12 transition-transform duration-300" />
          <span className="hidden sm:inline font-medium text-sm">Chat with us</span>
        </button>
      )}

      {/* Chat Window */}
      {isOpen && (
        <div className="fixed bottom-6 right-6 left-6 sm:left-auto z-50 animate-in fade-in slide-in-from-bottom-4 duration-300 flex justify-end">
          <div className="relative rounded-2xl overflow-hidden shadow-2xl ring-1 ring-black/10 w-full sm:w-auto">
            {/* Header Bar */}
            <div
              style={{ backgroundColor: INDOJET_NAVY }}
              className="flex items-center justify-between px-4 py-3"
            >
              <div className="flex items-center gap-2">
                <Send size={16} className="text-white/80" />
                <span className="text-white font-semibold text-sm">IndoJet Travel Assistant</span>
              </div>
              <button
                onClick={() => setIsOpen(false)}
                className="text-white/70 hover:text-white hover:bg-white/10 rounded-full p-1 transition-colors"
                aria-label="Close AI Travel Assistant"
              >
                <X size={18} />
              </button>
            </div>

            {/* Chat Iframe */}
            <iframe
              src={chatUrl}
              className="block w-full h-[520px] sm:w-[440px] sm:h-[580px] md:w-[480px] border-0 bg-white"
              title="AI Travel Assistant"
              allow="clipboard-write"
            />
          </div>
        </div>
      )}
    </>
  )
}

export default ChatWidget
